import { NgModule } from '@angular/core'
import { RouterModule, Routes, PreloadAllModules, mapToCanActivate } from '@angular/router'
import { startPageGuard } from '@core'
import { authSimpleCanActivate } from '@delon/auth'
import { environment } from '@env/environment'
// layout
import { CanActivateGuard } from '@utils/CanActivateGuard'

import { DashboardComponent } from './dashboard/dashboard.component'
// dashboard pages
// single pages
import { CallbackComponent } from './passport/callback.component'
// passport pages
import { UserLoginComponent } from './passport/login/login.component'
import { UserRegisterComponent } from './passport/register/register.component'
import { UserResetComponent } from './passport/reset/reset.component'
import { LayoutBasicComponent } from '../layout/basic/basic.component'
import { LayoutBlankComponent } from '../layout/blank/blank.component'
import { LayoutPassportComponent } from '../layout/passport/passport.component'

const routes: Routes = [
  {
    path: '',
    component: LayoutBasicComponent,
    canActivate: [startPageGuard, authSimpleCanActivate],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
        canActivateChild: mapToCanActivate([CanActivateGuard]),
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: mapToCanActivate([CanActivateGuard]),
      },
      {
        path: 'exception',
        loadChildren: () => import('./exception/exception.module').then((m) => m.ExceptionModule),
      },
      {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
        canActivateChild: mapToCanActivate([CanActivateGuard]),
      },
      {
        path: 'standard',
        loadChildren: () => import('./standard/standard.module').then((m) => m.StandardModule),
        canActivateChild: mapToCanActivate([CanActivateGuard]),
      },
      {
        path: 'unit',
        loadChildren: () => import('./unit/unit.module').then((m) => m.UnitModule),
        canActivateChild: mapToCanActivate([CanActivateGuard]),
      },
      {
        path: 'carbon',
        loadChildren: () => import('./carbon/carbon.module').then((m) => m.CarbonModule),
        canActivateChild: mapToCanActivate([CanActivateGuard]),
      },
      {
        path: 'support',
        loadChildren: () => import('./support/support.module').then((m) => m.SupportModule),
        canActivateChild: mapToCanActivate([CanActivateGuard]),
      },
      {
        path: 'alarm',
        loadChildren: () => import('./alarm/alarm.module').then((m) => m.AlarmModule),
      },
      {
        path: 'device',
        loadChildren: () => import('./device/device.module').then((m) => m.DeviceModule),
      },
      {
        path: 'bigscreendata',
        loadChildren: () =>
          import('./bigscreendata/bigscreendata.module').then((m) => m.BigscreendataModule),
      },
      {
        path: 'production',
        loadChildren: () =>
          import('./production/production.module').then((m) => m.ProductionModule),
        canActivateChild: mapToCanActivate([CanActivateGuard]),
      },
      {
        path: 'esg',
        loadChildren: () => import('./esg/esg.module').then((m) => m.EsgModule),
        canActivateChild: mapToCanActivate([CanActivateGuard]),
      },
      {
        path: 'cbam',
        loadChildren: () => import('./cbam/cbam.module').then((m) => m.CbamModule),
        canActivateChild: mapToCanActivate([CanActivateGuard]),
      },
      {
        path: 'log',
        loadChildren: () => import('./log/log.module').then((m) => m.LogModule),
        canActivateChild: mapToCanActivate([CanActivateGuard]),
      },
    ],
  },
  // 空白布局
  {
    path: 'blank',
    component: LayoutBlankComponent,
    children: [
      {
        path: 'bigscreen',
        loadChildren: () => import('./bigscreen/bigscreen.module').then((m) => m.BigscreenModule),
      },
    ],
  },
  // passport
  {
    path: 'passport',
    component: LayoutPassportComponent,
    children: [
      { path: 'login', component: UserLoginComponent, data: { title: '登录' } },
      //{ path: 'register', component: UserRegisterComponent, data: { title: '注册' } },
      { path: 'reset', component: UserResetComponent, data: { title: '忘记密码' } },
    ],
  },
  // 单页不包裹Layout
  { path: 'passport/callback/:type', component: CallbackComponent },
  { path: '**', redirectTo: 'exception/404' },
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: environment.useHash,
      // NOTICE: If you use `reuse-tab` component and turn on keepingScroll you can set to `disabled`
      // Pls refer to https://ng-alain.com/components/reuse-tab
      scrollPositionRestoration: 'top',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class RouteRoutingModule {}
